/**
 * New metric names from timeseries-db-client package.
 * These are semantic metric identifiers that map to sensor data.
 */
export enum TSMetric {
    // Gas concentrations
    CO2_CONCENTRATION = "CO2_CONCENTRATION",
    CO2_INPUT = "CO2_INPUT",
    CO2_OUTPUT = "CO2_OUTPUT",
    O2_CONCENTRATION = "O2_CONCENTRATION",
    CO_CONCENTRATION = "CO_CONCENTRATION",
    NO2_CONCENTRATION = "NO2_CONCENTRATION",
    SO2_CONCENTRATION = "SO2_CONCENTRATION",
    CH4_CONCENTRATION = "CH4_CONCENTRATION",
    HCHO_CONCENTRATION = "HCHO_CONCENTRATION",

    // Environmental
    STACK_TEMPERATURE = "STACK_TEMPERATURE",
    HUMIDITY = "HUMIDITY",
    STATIC_PRESSURE = "STATIC_PRESSURE",
    DIFFERENTIAL_PRESSURE = "DIFFERENTIAL_PRESSURE",
    DIFFERENTIAL_PRESSURE_TEMPERATURE_1 = "DIFFERENTIAL_PRESSURE_TEMPERATURE_1",
    DIFFERENTIAL_PRESSURE_TEMPERATURE_2 = "DIFFERENTIAL_PRESSURE_TEMPERATURE_2",
    VELOCITY = "VELOCITY",

    // Refrigerant temperatures
    COMPRESSOR_OUTLET_TEMP = "COMPRESSOR_OUTLET_TEMP",
    COMPRESSOR_INLET_TEMP = "COMPRESSOR_INLET_TEMP",
    CONDENSER_INLET_TEMP = "CONDENSER_INLET_TEMP",
    CONDENSER_OUTLET_TEMP = "CONDENSER_OUTLET_TEMP",
    EVAPORATOR_INLET_TEMP = "EVAPORATOR_INLET_TEMP",
    EVAPORATOR_OUTLET_TEMP = "EVAPORATOR_OUTLET_TEMP",
    LIQUID_LINE_TEMP = "LIQUID_LINE_TEMP",
    ENCLOSURE_TEMPERATURE = "ENCLOSURE_TEMPERATURE",
    AIR_SUPPLY_TEMP = "AIR_SUPPLY_TEMP",
    AIR_RETURN_TEMP = "AIR_RETURN_TEMP",
    LIQUID_SERVICE_VALVE_2_TEMP = "LIQUID_SERVICE_VALVE_2_TEMP",
    TC1_GENERIC_TEMP = "TC1_GENERIC_TEMP",
    TC2_GENERIC_TEMP = "TC2_GENERIC_TEMP",
    TC3_GENERIC_TEMP = "TC3_GENERIC_TEMP",
    TC4_GENERIC_TEMP = "TC4_GENERIC_TEMP",
    TC5_GENERIC_TEMP = "TC5_GENERIC_TEMP",
    ALL_TEMPERATURES = "ALL_TEMPERATURES",

    // Pressure
    SUCTION_PRESSURE = "SUCTION_PRESSURE",
    DISCHARGE_PRESSURE = "DISCHARGE_PRESSURE",

    // Electrical
    PHASE_A_VOLTAGE = "PHASE_A_VOLTAGE",
    PHASE_B_VOLTAGE = "PHASE_B_VOLTAGE",
    PHASE_C_VOLTAGE = "PHASE_C_VOLTAGE",
    ALL_PHASE_VOLTAGES = "ALL_PHASE_VOLTAGES",
    PHASE_A_CURRENT = "PHASE_A_CURRENT",
    PHASE_B_CURRENT = "PHASE_B_CURRENT",
    PHASE_C_CURRENT = "PHASE_C_CURRENT",
    ALL_PHASE_CURRENTS = "ALL_PHASE_CURRENTS",
    ALL_PHASE_POWERS = "ALL_PHASE_POWERS",
    ACTIVE_POWER = "ACTIVE_POWER",

    // Particulates
    PARTICULATES_PM1_0 = "PARTICULATES_PM1_0",
    PARTICULATES_PM2_5 = "PARTICULATES_PM2_5",
    PARTICULATES_PM10 = "PARTICULATES_PM10",

    // Refrigerant leak detection
    REFRIGERANT_CONCENTRATION = "REFRIGERANT_CONCENTRATION",
}
